import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import styles from './UserManagementUsersEditTemplate.module.css';
import { Button, Label, TabItem } from '../../atoms';
import { TabBar } from '../../molecules';

interface UserManagementUsersEditTemplateProps {
  children: React.ReactNode;
}

const UserManagementUsersEditTemplate: React.FC<
  UserManagementUsersEditTemplateProps
> = ({ children }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content={'User'} size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate('/user-management/users')}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="User Details"
          id={`/user-management/users/${id}/edit/details`}
        />
        <TabItem title="Roles" id={`/user-management/users/${id}/edit/roles`} />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default UserManagementUsersEditTemplate;
